import styled from "@emotion/styled"

const TestimonialBottom = styled.div`
  display: flex;
  gap: 36px;
`

export default TestimonialBottom
